<template>
  <dara-icon-action-content-layout v-if="visible">
    <template #icon>
      <dara-icon size="md" :icon="icon" :class="notificationClass" />
    </template>
    <template #main>
      <dara-row>
        <dara-col :md="19" :sm="20">
          <div @click="markAsRead()">
            <dara-p v-truncate weight="strong" margin="sm" size="md" :color="wasNotReaded ? 'base' : 'info'">
              <component :is="component" v-if="isAnonymous" :id="data.reference_id">
                {{ $t('a-user') }} {{ $t(data.title) }}
              </component>
              <component :is="component" v-else :id="data.reference_id">
                {{ contentUser }} {{ $t(data.title) }}
              </component>
            </dara-p>
            <dara-p v-truncate margin="sm" size="md" :color="wasNotReaded ? 'base' : 'info'">
              <component :is="component" v-if="content" :id="data.reference_id">
                {{ contentTitle }}
              </component>
            </dara-p>
            <dara-small v-truncate>{{ $t('created-on') }} {{ createdAt() }} • {{ $t('in') }} {{ contentDepartment }}</dara-small>
          </div>
        </dara-col>
        <dara-col v-if="wasNotReaded" :md="5" :sm="4" justify="right">
          <el-badge is-dot type="primary" class="badge"></el-badge>
        </dara-col>
      </dara-row>
    </template>
  </dara-icon-action-content-layout>
</template>

<script>
import { formatDate } from '@/helpers/date';
import { markNotificationAsRead } from '@/modules/notification/notification.service';
import { getCurrentStoredUser } from '@/modules/user/user.service';
import { NOTIFICATION_TYPES, NOTIFICATION_ICONS, NOTIFICATION_LINKS } from '@/modules/notification/notification.contants';
import { getArticleById } from '@/modules/article/article.service';
import { getTrackById } from '@/modules/track/track.service';
import { getQuestion, getAnswer } from '@/modules/question/question.service';

import DaraIconActionContentLayout from '@/layouts/IconActionContentLayout.vue';

export default {
  name: 'DaraNotificationCard',
  components: {
    DaraIconActionContentLayout,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      user: null,
      date: null,
      content: null,
    };
  },
  computed: {
    isAnonymous() {
      return this.content && this.content.anonymous;
    },
    visible() {
      return !this.data.deleted_at;
    },
    icon() {
      return NOTIFICATION_ICONS[NOTIFICATION_TYPES[this.data.reference_type]];
    },
    component() {
      return NOTIFICATION_LINKS[this.data.reference_type];
    },
    wasNotReaded() {
      return !this.data.readed_at;
    },
    notificationClass() {
      return this.wasNotReaded ? 'color--base' : 'color-info';
    },
    contentUser() {
      if (this.data.title === 'followed-track-updated') {
        return '';
      }
      return this.content && this.content.user ? this.content.user.name : '';
    },
    contentTitle() {
      return this.content.title ? this.content.title : this.content.name;
    },
    contentDepartment() {
      return this.content && this.content.department ? this.content.department.name : '';
    },
  },
  created() {
    this.createdAt();
    this.fetchContent();
  },
  methods: {
    fetchContent() {
      const type = this.data.reference_type;
      const contentId = this.data.reference_id;

      if (type.includes('article')) {
        this.getArticle(contentId);
      } else if (type.includes('question')) {
        this.getQuestion(contentId);
      } else if (type.includes('track')) {
        this.getTrack(contentId);
      } else if (type.includes('answer')) {
        this.getAnswer(contentId);
      }
    },
    getArticle(id) {
      getArticleById(id)
        .then(({ data }) => {
          this.content = data;
        });
    },
    getQuestion(id) {
      getQuestion(id)
        .then(({ data }) => {
          this.content = data;
        });
    },
    getTrack(id) {
      getTrackById(id)
        .then(({ data }) => {
          this.content = data;
        });
    },
    getAnswer(id) {
      getAnswer(id)
        .then(({ data }) => {
          this.$set(this.data, 'reference_id', data.question_id);
          this.content = data;
          this.content.title = data.question.title;
        });
    },
    createdAt() {
      this.user = getCurrentStoredUser();
      if (this.user.language === 'pt-br') {
        return formatDate(this.data.created_at, 'DD/MM/YYYY');
      }
      return formatDate(this.data.created_at, 'YYYY-MM-DD');
    },
    markAsRead() {
      markNotificationAsRead(this.data);
    },
  },
};
</script>

<style scoped>
 .badge {
   padding-top: 40px;
 }
</style>
